import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { FieldError } from 'react-hook-form/dist/types';

interface BaseInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  invalid?: FieldError | unknown;
}

/** Component for <input /> element. */
const BaseInput = forwardRef<HTMLInputElement, BaseInputProps>((props, ref) => {
  const { invalid, className, ...rest } = props;

  const inputClassName = classNames('form-control', className, {
    invalid,
  });

  return (
    <div className="form-group">
      <input ref={ref} className={inputClassName} {...rest} />
    </div>
  );
});

BaseInput.displayName = 'BaseInput';

export default BaseInput;
